import * as React from 'react'
import { Checkbox, Grid, Paper, Select, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { postAnswerForm, getParams } from 'api/fieldNotebooks'
import styles from './styles.js'
import './styles.css'

import Resume from './components/Resume'
import ActionsBar from './components/ActionsBar.js'
import FormContents from './FormContents.js'

const useStyles = makeStyles(styles)

const fields = {
  'select': <Select />,
  'checkbox': <Checkbox />
}

function FormStepper(form) {
  const [formSelected, setFormSelected] = React.useState(form.form)
  const [answers, setAnswers] = React.useState([])
  const [isResume, setIsResume] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const classes = useStyles()
  const [activeStep, setActiveStep] = React.useState(0)
  const maxSteps = formSelected.fields ? formSelected.fields.length : 1
  let history = useHistory()

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }

  const handleChange = (index) => (e) => {
    setActiveStep(index)
  }

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const { jwt } = getParams(history.location.search)
      const { data, status } = await postAnswerForm({ 
        response: { answers: answers },
        jwt: jwt
      })

      if (status === 201) {
        window.location.reload()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  const handleResume = () => {
    setIsResume(true)
  }

  const handleInput = (field_id, value) => {
    const newAnswers = [...answers]

    if (answers.find(field => field.field_id === field_id)) {
      const index = answers.findIndex(field => field.field_id === field_id)
      newAnswers[index] = {
        'field_id': field_id,
        'value': value
      }
    } else {
      newAnswers.push({
        'field_id': field_id,
        'value': value
      })
    }

    setAnswers(newAnswers)
  }

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.header}>
        {!isResume && <Grid
          container
          direction='column'
          alignItems='center'
          alignContent='center'
          spacing={1}
        >
          <Grid item xs={12}><Typography>{formSelected.title || ''}</Typography></Grid>

          <Grid item xs={12}><Typography variant='caption'>{formSelected.fields[activeStep].description.replace(/<[^>]*>?/gm, '') || ''}</Typography></Grid>
          <Grid item xs={12}><Typography variant='caption'>{!formSelected.fields
            ? ''
            : formSelected.fields[activeStep].placeholder}
          </Typography></Grid>
          <Grid item xs={12} >
            <FormContents
              classes={classes}
              handleSubmit={handleSubmit}
              activeStep={activeStep}
              handleChange={handleChange}
              formSelected={formSelected}
              handleInput={handleInput}
              fields={fields}
            />
          </Grid>

        </Grid>}

        {isResume && (
          <Resume
            classes={classes}
            answers={answers}
            formSelected={formSelected}
            setIsResume={setIsResume}
            loading={loading}
            handleSubmit={handleSubmit}
          />
        )}
      </Paper>
      <Grid item xs={12}>
        {!isResume && (
          <ActionsBar
            maxSteps={maxSteps}
            activeStep={activeStep}
            handleResume={handleResume}
            handleNext={handleNext}
            handleBack={handleBack}
            numAnswers={answers.length}
          />
        )}
      </Grid>
    </div >
  )
}

export default FormStepper